import { Text12 } from "components/Text";
import { basicShortDate, dateToTime } from "helpers/time";
import { TaskDependencyPill } from "features/Trigger/TemplateTrigger/Components/TaskDependencyPill";
import { TaskId } from "features/Resources/Task/models";
import moment from "moment";
import normalizeSendAt from "../helpers/normalizeSendAt";
import { ActionSummary, ActionV2 } from "../models";

function formatDateWithTime(value: Date) {
  const date = basicShortDate(value);
  const time = dateToTime(value);
  if (!time || time === "12:00am") return date;
  return `${date} ${time}`;
}

interface ActionPrimarySendAtProps {
  action: ActionSummary | ActionV2;
  size: "sm" | "md";
}

export default function PrimarySendAtValue({ action, size = "md" }: ActionPrimarySendAtProps) {
  const normalizedSendAt = normalizeSendAt(action);
  // if the date value is there, return the date value - for dependency where a 'delivered_at' or
  // 'started_at' was set, then the date will be shown and not the dependency information.
  if (normalizedSendAt.dateValue) {
    return <Text12>{formatDateWithTime(normalizedSendAt.dateValue)}</Text12>;
  } else if (normalizedSendAt.triggerType === "dependency") {
    return <TaskDependencyPill taskId={normalizedSendAt.dependencyId as TaskId} size={size} />;
    // if there is no dateValue for 'deliveredAt' or startedAt', and its immediate, display today
  } else if (normalizedSendAt.isImmediate && !normalizedSendAt.dateValue) {
    return <Text12>{basicShortDate(moment().toDate())}</Text12>;
  }
  return null;
}
